import get from 'lodash/get';
import update from 'lodash/update';
import findIndex from 'lodash/findIndex';
import cloneDeep from 'lodash/cloneDeep';

export const joinString = (arr = [], symbol = ' ') =>
  arr.filter(Boolean).join(symbol);

export function updateDeep(target, path, updater) {
  if (typeof updater !== 'function') return target;

  if (typeof path === 'string') {
    return update(cloneDeep(target), path, updater);
  }

  const safePath = path.reduce((result, entity) => {
    switch (typeof entity) {
      case 'number':
        return `${result}[${entity}]`;
      case 'string':
        return joinString([result, entity], '.');
      default:
        return `${result}[${findIndex(get(target, result) || target, entity)}]`;
    }
  }, '');

  return update(cloneDeep(target), safePath, updater);
}



// WEBPACK FOOTER //
// ./src/utils/updateDeep.js